import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeatureFlagsDirective } from './feature-flags.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [FeatureFlagsDirective],
  exports: [FeatureFlagsDirective],
})
export class FeatureFlagsModule {}
